module.exports = __webpack_public_path__ + "assets/img/20.0c5276e0.png";